<template>
  <div v-if="result" class="product-modal">
    <DefImg :result="result.picture ?? result.morePhotos[0]" />
    <div class="product-modal-description">
      <a :href="result.detailPage" class="product-modal-description__name">
        {{ result.name }}
      </a>
      <!--            <a-->
      <!--                v-if="result.collection"-->
      <!--                :href="result.collection.detailPage"-->
      <!--                class="product-modal-description__collection"-->
      <!--            >-->
      <!--                {{ result.collection.name }}-->
      <!--            </a>-->
      <p class="product-modal-description__article">арт. {{ result.article }}</p>
    </div>
    <div
      v-if="result.propsForCheck && result.propsForCheck.SIZES"
      class="product-modal-prop product-modal-size"
    >
      <p class="product-modal-prop__name">
        <!--                <DefProgramMe tag="span">-->
        <!--                    Розмір-->
        <!--                </DefProgramMe>-->
        {{ state.results.messages.size }}
        <!--                {{ result.skuMatrix.SIZES.title }}-->
      </p>
      <p v-if="getActiveSize" class="product-modal-prop__value">
        {{ getActiveSize.name }}
      </p>
    </div>
    <div class="product-modal-prop product-modal-count">
      <p class="product-modal-prop__name">
        {{ state.results.messages.amount }}
      </p>
      <p class="product-modal-prop__value">
        {{ result?.price?.quantity }}
      </p>
    </div>
    <div v-if="result.price" class="product-modal-prices">
      <DefPriceOld v-if="result.price.printPriceOld">
        {{ result.price.printPriceOld }}
      </DefPriceOld>
      <DefPrice v-if="result.price.printPrice">
        {{ result.price.printPrice }}
      </DefPrice>
      <DefSale v-if="result.price.printDiscountPercent">
        {{ result.price.printDiscountPercent }}
      </DefSale>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { useStore } from '@store';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefSale from '@components/Def/DefSale/DefSale.vue';

const { result } = defineProps(['result', 'messages']);

const { state, getters } = useStore();

const getActiveSize = computed(() => result?.propsForCheck?.SIZES?.find((el) => el.active));
</script>

<script>
export default {
  name: 'ProductModal',
};
</script>

<style lang="scss" scoped>
.product-modal {
  display: grid;
  grid-template-columns: 64px 1.3fr 1fr;
  grid-column-gap: 8px;
  grid-template-areas:
    'img description prices'
    'img size prices'
    'img count prices';
  padding: 12px 8px;
  border: 1px solid var(--border-grey);
  @include point-md {
    padding: 10px;
    grid-template-columns: 80px 1.5fr 1fr 1fr 1fr;
    grid-template-areas: 'img description size count prices';
    align-items: center;
  }
  :deep(.def-img) {
    grid-area: img;
  }
}
.product-modal-description {
  display: flex;
  flex-direction: column;
  grid-area: description;
  margin-bottom: 8px;
  @include point-md {
    margin-bottom: 0;
  }
  &__name {
    font-weight: 500;
    font-size: rem(14);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 6px;
    @include point-md {
      font-size: rem(16);
    }
  }
  //&__collection{
  //    font-weight: 400;
  //    font-size: rem(10);
  //    letter-spacing: 0.08em;
  //    text-transform: uppercase;
  //    color: var(--color-dark-grey);
  //    margin-bottom: 12px;
  //    @include point-md{
  //        margin-bottom: 10px;
  //        font-size: rem(12);
  //    }
  //}
  &__article {
    font-weight: 400;
    font-size: rem(11);
    line-height: 110%;
    color: var(--color-dark-grey);
  }
}
.product-modal-prop {
  display: flex;
  @include point-md {
    flex-direction: column;
  }
  &__name {
    font-weight: 500;
    font-size: rem(12);
    line-height: 120%;
    @include point-md {
      font-size: rem(10);
      line-height: 100%;
      color: var(--color-dark-grey);
      margin-bottom: 6px;
    }
    &:after {
      content: ': ';
      margin-right: 2px;
      @include point-md {
        content: '';
      }
    }
  }
  &__value {
    font-weight: 500;
    font-size: rem(12);
    line-height: 120%;
    @include point-md {
      font-size: rem(16);
      line-height: 100%;
    }
  }
}
.product-modal-count {
  grid-area: count;
}
.product-modal-size {
  grid-area: size;
}
.product-modal-prices {
  display: flex;
  flex-direction: column;
  grid-area: prices;
  align-self: flex-end;
  justify-self: flex-end;
  text-align: end;
  :deep(.def-price-old) {
    font-size: rem(9);
    margin-bottom: 4px;
    @include point-md {
      font-size: rem(14);
    }
  }
  :deep(.def-price) {
    font-size: rem(14);
    margin-bottom: 6px;
    @include point-md {
      font-size: rem(18);
      margin-bottom: 8px;
    }
  }
  :deep(.def-sale) {
    font-size: rem(9);
    @include point-md {
      font-size: rem(11);
    }
  }
}
</style>
